var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-transitions container-fluid flex-grow-1 map-home"},[_c('router-view'),(_vm.$route.name === 'map-home')?_c('div',{staticClass:"p-5 text-big"},[_vm._v("You need to create and publish at least one floor...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }